export const dateMenuItems = [
  'Select Date',
  'Last 7 Days',
  'Last 30 Days',
  'Last 3 Months',
  'Custom Range',
];

export const gatewayMenuItems = [
  'Billdesk1',
  'Billdesk2',
  'CamsPay',
  'RazorPay',
  'Cashfree',
  'EPay',
];
